import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { fmtFecha } from "../../lib/format";
import { PAISES } from "../../lib/kycData";
import { PageHeader } from "../../components/PageHeader";
import { StatusBadge } from "../../components/StatusBadge";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

export const ESTADOS_CLIENTE = ["pendiente_kyc", "en_revision", "aprobado", "rechazado", "bloqueado", "requiere_actualizacion"];
export const NIVEL = { bajo: "ok", medio: "pendiente_verificacion", alto: "fallido", bloqueado: "bloqueado" };
export const ESTADO_STYLE = { aprobado: "ok", aprobado_provisional: "ok", en_revision: "pendiente_verificacion", pendiente_kyc: "pendiente_verificacion", rechazado: "rechazado", bloqueado: "bloqueado", requiere_actualizacion: "suspendida" };

const Sel = ({ value, onChange, options, label, testId }) => (
  <select className="h-9 border rounded-md px-2 text-sm bg-white" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
    <option value="">{label}</option>
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

export default function Clientes() {
  const [f, setF] = useState({ q: "", riesgo: "", estado: "", nacionalidad: "", pep: "" });
  const [items, setItems] = useState([]);
  useEffect(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v !== ""));
    const t = setTimeout(() => api.get("/company/clientes", { params }).then((r) => setItems(r.data.items)), 250);
    return () => clearTimeout(t);
  }, [f]);
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const exportar = async () => {
    const r = await api.get("/company/export/cartera.csv", { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = "cartera.csv";
    a.click();
  };
  return (
    <div className="space-y-6">
      <PageHeader overline="Cumplimiento" title="Mis clientes">
        <Button variant="outline" onClick={exportar} data-testid="export-csv-button">Exportar cartera (CSV)</Button>
      </PageHeader>
      <div className="flex flex-wrap gap-2" data-testid="clients-filters">
        <Input className="w-64 h-9" placeholder="Buscar por nombre o documento" value={f.q} onChange={(e) => set("q")(e.target.value)} data-testid="clients-search" />
        <Sel value={f.riesgo} onChange={set("riesgo")} label="Riesgo" options={["bajo", "medio", "alto", "bloqueado"].map((x) => [x, x])} testId="filter-riesgo" />
        <Sel value={f.estado} onChange={set("estado")} label="Estado" options={ESTADOS_CLIENTE.map((x) => [x, x])} testId="filter-estado" />
        <Sel value={f.nacionalidad} onChange={set("nacionalidad")} label="Nacionalidad" options={PAISES.map((p) => [p.code, p.name])} testId="filter-nacionalidad" />
        <Sel value={f.pep} onChange={set("pep")} label="PEP" options={[["true", "Sí"], ["false", "No"]]} testId="filter-pep" />
      </div>
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
        <Table data-testid="clients-table">
          <TableHeader><TableRow>{["Nombre", "Documento", "Nacionalidad", "Puntaje", "Nivel", "Estado", "Última revisión"].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
          <TableBody>
            {items.map((c) => (
              <TableRow key={c.id} data-testid={`client-row-${c.id}`}>
                <TableCell><Link to={`/panel/clientes/${c.id}`} className="underline font-medium">{c.nombres} {c.apellido_paterno} {c.apellido_materno || ""}</Link>{c.riesgo?.diligencia_reforzada_obligatoria && <span className="block text-[11px] text-amber-700">diligencia reforzada obligatoria</span>}</TableCell>
                <TableCell className="font-mono text-xs">{c.documento.numero}</TableCell>
                <TableCell>{c.nacionalidad}</TableCell>
                <TableCell>{c.riesgo?.puntaje ?? "—"}</TableCell>
                <TableCell>{c.riesgo ? <StatusBadge value={NIVEL[c.riesgo.nivel]} label={c.riesgo.nivel} /> : "—"}</TableCell>
                <TableCell><StatusBadge value={ESTADO_STYLE[c.estado]} label={c.estado} /></TableCell>
                <TableCell className="text-xs">{fmtFecha(c.ultima_revision)}</TableCell>
              </TableRow>
            ))}
            {!items.length && <TableRow><TableCell colSpan={7} className="text-center text-slate-500 py-8">Sin clientes</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
